import { render, staticRenderFns } from "./documentView.vue?vue&type=template&id=511b850a&scoped=true"
import script from "./documentView.vue?vue&type=script&lang=js"
export * from "./documentView.vue?vue&type=script&lang=js"
import style0 from "./documentView.vue?vue&type=style&index=0&id=511b850a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b850a",
  null
  
)

export default component.exports